var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"33.5","cy":"33.5","r":"33.5","fill":"#13B132","fillOpacity":"0.6","key":0}),React.createElement("path",{"d":"M23.8911 26.3804L18.5693 31.1612L32.2515 46.4025L57.1579 15.0926L51.5498 10.6379L31.9254 35.3136L23.8911 26.3804Z","fill":"white","key":1})]);
}

Checkmark.defaultProps = {"width":"67","height":"67","viewBox":"0 0 67 67","fill":"none"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
